import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';

/**
 * Generic, content-agnostic modal. The parent controls visibility via [open]
 * and listens for (closed). The body accepts rich HTML (rendered with the
 * `.rich-text` Quill styles).
 */
@Component({
  selector: 'app-info-modal',
  templateUrl: './info-modal.component.html',
  styleUrls: ['./info-modal.component.scss'],
})
export class InfoModalComponent {
  @Input() open = false;
  @Input() title = '';
  /** HTML content (e.g. a rich-text "full description") */
  @Input() content = '';

  @Output() closed = new EventEmitter<void>();

  close(): void {
    this.closed.emit();
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.open) {
      this.close();
    }
  }
}
